import { render, staticRenderFns } from "./BigProductsBlock.vue?vue&type=template&id=64a9a4d0&scoped=true&"
import script from "./BigProductsBlock.vue?vue&type=script&lang=ts&"
export * from "./BigProductsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./BigProductsBlock.vue?vue&type=style&index=0&id=64a9a4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9a4d0",
  null
  
)

export default component.exports